

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { GatePass } from '../_models/gate_pass';
import { Guardian } from '../_models/guardian';
import { ResultData } from '../_models/ResultData';
import { Student } from '../_models/student';
import { User } from '../_models/user';




const TOKEN_KEY = 'access_token';
const USER_KEY = 'user';
@Injectable({ providedIn: 'root' })
export class AuthService {
    public userSubject= new BehaviorSubject(this.getUserDataObject());
    public gatePass=new BehaviorSubject(new GatePass())
    public gatePassData = new GatePass()
    aHeader = undefined
    constructor(
        private router: Router,
        private http: HttpClient){}

    public get userValue(): User {
        return this.userSubject.value;
    }
    public myGatePass(){
      return this.gatePass.asObservable()
    }
    getAuthenticatedUserId(token:string) :Observable<ResultData>{

      let bearerJsonHeaders = { headers: new HttpHeaders({ 'Content-Type': 'application/json','Authorization':`Bearer ${token}`}) };
      return this.http.get<ResultData>(`${environment.apiUrl}/user/getUserId`, bearerJsonHeaders)
    }

    login(username: string, password: string): Observable<any>  {
      this.deleteKeys()
      return this.http.post<any>(`${environment.apiUrl}/login`, { username, password })
          .pipe(
            catchError(this.handleError)
          );
  }

    private handleError(error: HttpErrorResponse) {
      if (error.status === 401) {

        alert('Invalid credentials. Please check your username and password.');
      } else {

        alert('An unexpected error occurred.');
      }

      return throwError(() => new Error(error.message));
    }

    publishGatePass(user:User){

      this.gatePassData.is_role_admin=this.isGranted("ROLE_ADMIN")|| this.isGranted("ADMIN")
      this.gatePassData.is_role_guardian=this.isGranted("ROLE_GUARDIAN")|| this.isGranted("GUARDIAN")
      this.gatePassData.is_role_student=this.isGranted("ROLE_STUDENT")|| this.isGranted("STUDENT")
      this.gatePassData.is_member_of_marketing=this.isMemberOf('MARKETING')
      this.gatePassData.is_member_of_admin = this.isMemberOf('ADMIN')
      if(user.id || user.access_token){
        this.gatePassData.user_id=user.id
        this.gatePassData.is_logged_in=true
        this.gatePassData.username=user.username
      }
      this.gatePass.next(this.gatePassData)
     }
     deleteKeys(){
      localStorage.removeItem(USER_KEY);
      localStorage.removeItem(TOKEN_KEY)
     }
    logout() {
        this.deleteKeys()
        this.userSubject.next(new User());
        this.router.navigate(['']);
        this.gatePass.next(new GatePass());
    }

    isMemberOf(groupName:string){
        let jo= this.getUserDataObject()
        let myRoles =jo==null? null: jo['groups']
        return myRoles==null? false: myRoles.includes(groupName);
    }

    isAuthorized(){
      let jo= this.getUserDataObject()
      return jo!=null
    }
      isGranted(roleName:string){
        let roles = null
        if(this.getUser()!=null){
          roles =this.getUser().roles;
        }

        return roles==null? false: roles.includes(roleName)
      }

      hasRole(roleName:string){
        return this.isGranted(roleName);

      }

      isAdmin(){
        return this.hasRole('ROLE_ADMIN')||this.hasRole("ADMIN")
      }
      isAnalytic(){
        return this.isMemberOf('MARKETING')
      }
      isStudent(){
          return this.hasRole("ROLE_STUDENT")||this.hasRole("STUDENT")
      }
      isGuardian(){
          return this.hasRole("ROLE_GUARDIAN") ||this.hasRole("GUARDIAN")
      }
      loggedInAs(){
        let jo= this.getUserDataObject()

        return jo!=null ? jo['username'] : ""

      }

      public getUser(): any {
        return  this.getUserDataObject()

      }
      getUserId(){
        let userData = this.getUserDataObject()
        return userData!=null?userData['id']:undefined
      }
      getGuardianStudentStatus(){
        let jo= this.getUserDataObject()
        return jo['guardian_student_status']

      }

      getStudentId(){
        let jo= this.getUserDataObject()
        return jo['server_student_id']

      }
      getGuardianId(){
        let jo= this.getUserDataObject()
        return jo['server_guardian_id']
      }
      isAuthorisedStudent(student:Student){
        return student.server_user_id ==this.getUserId()
      }

      isAuthorisedGuardian(guardian:Guardian){
        return guardian.server_user_id == this.getUserId()
      }
      processHomeRoute(pp:GatePass){

        let ll=[]
        if(pp.is_role_admin){
          ll=["/home/admin/show"]

        }else if(pp.is_role_guardian){
          ll=['/guardian/show',pp.user_id]

        }else if(pp.is_role_student){
          ll=["/student/show",pp.user_id]

        }else if(pp.is_role_teacher){
          ll=["/teacher/show",pp.user_id]

        }else{
          ll=["/"]
        }
        return ll
      }

      getHomeRoute(pp:GatePass){
        let ll=[]
        if(!pp.is_logged_in){
          ll=["/"]
        }else{
          ll=this.processHomeRoute(pp)
        }
        return ll
      }
      saveUser(user:any){
        let userString=JSON.stringify(user);
        localStorage.setItem(USER_KEY, userString);
      }
      static getToken(){
        let userData = localStorage.getItem(USER_KEY)|| JSON.stringify({})
        let jo= JSON.parse(userData)
        return jo[TOKEN_KEY]||null

      }
      public saveToken(token: string): void {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.setItem(TOKEN_KEY, token);
      }

      public getToken(): string {
        if(localStorage){
          return localStorage.getItem(TOKEN_KEY)
        }else{
          return ""
        }

      }
      getUserDataObject(){
        let data= localStorage.getItem(USER_KEY)|| JSON.stringify({id:undefined})
        return JSON.parse(data)
      }
}
